module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "shaded mx-4 my-4",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.next($event)
      }
    }
  }, [(!_vm.getSelectedPerson) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center my-1 py-2"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "submit",
      "value": "Next",
      "disabled": _vm.$v.form.$invalid
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row mb-0"
  }, [(_vm.showExistingAgentSelector) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_c('agent-existing-selector', {
    on: {
      "valueChanged": _vm.useExistingOrCreateChanged
    }
  })], 1) : (!this.getSelectedPerson) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_c('agent-virtual-or-invite', {
    on: {
      "valueChanged": _vm.createOffilneOrInviteAgent
    },
    model: {
      value: (_vm.form.saveAndSend),
      callback: function($$v) {
        _vm.$set(_vm.form, "saveAndSend", $$v)
      },
      expression: "form.saveAndSend"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    class: _vm.getSelectedPerson ? 'col-sm-12' : 'col-sm-7'
  }, [_c('div', {
    staticClass: "shaded",
    class: _vm.getSelectedPerson ? '' : 'panel'
  }, [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.getSelectedPerson) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('span', [_vm._v("PROFILE")]), _vm._v(" "), (_vm.form.isLoading) ? _c('div', {
    staticClass: "d-flex justify-content-right align-items-center position-relative"
  }, [_c('loader')], 1) : (!_vm.passedForm.isOTA) ? _c('div', {
    staticClass: "d-flex justify-content-right align-items-center position-relative"
  }, [(_vm.passedForm.inviteStatus == 5) ? _c('button', {
    staticClass: "btn blue mr-2",
    on: {
      "click": function($event) {
        return _vm.callInviteAgent(_vm.passedForm)
      }
    }
  }, [_vm._v("Connect")]) : _vm._e(), _vm._v(" "), (_vm.passedForm.inviteStatus == 0) ? _c('button', {
    staticClass: "btn blue mr-2",
    attrs: {
      "disabled": _vm.emailChanged
    },
    on: {
      "click": function($event) {
        return _vm.callInviteAgent(_vm.passedForm)
      }
    }
  }, [_vm._v("Invite")]) : _c('span', {
    staticClass: "btn cursor-default radius-stadium",
    class: _vm.peopleInviteStatus(_vm.passedForm).colorClass
  }, [_vm._v(_vm._s(_vm.peopleInviteStatus(_vm.passedForm).label))]), _vm._v(" "), (_vm.listActions.length > 0) ? _c('three-dots', {
    attrs: {
      "items": _vm.listActions
    },
    on: {
      "input": _vm.selectedConnectionAction
    }
  }) : _vm._e()], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    class: {
      error: _vm.$v.form.brandName.$error
    }
  }, [(_vm.useExistingAgent) ? _c('div', {
    staticClass: "full"
  }, [_vm._m(0), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.availableAgents,
      "label": "brandName",
      "placeholder": "Select an agent"
    },
    on: {
      "input": _vm.agentSelceted
    },
    model: {
      value: (_vm.existingSelectedAgent),
      callback: function($$v) {
        _vm.existingSelectedAgent = $$v
      },
      expression: "existingSelectedAgent"
    }
  })], 1) : _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Name "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.brandName),
      expression: "form.brandName"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.passedForm.isOTA
    },
    domProps: {
      "value": (_vm.form.brandName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "brandName", $event.target.value)
      }, _vm.$v.form.brandName.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.brandName.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.brandName.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.brandName.minLength) ? _c('span', [_vm._v("Name must have at least 3 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Code\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.getChannelSalesList && !_vm.passedForm.isOTA) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Business Type")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getChannelSalesList,
      "placeholder": "Pick a sales channel",
      "searchable": true,
      "label": "description"
    },
    on: {
      "input": _vm.updateRole
    },
    model: {
      value: (_vm.selectedRole),
      callback: function($$v) {
        _vm.selectedRole = $$v
      },
      expression: "selectedRole"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6",
    class: {
      error: _vm.$v.form.email.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Email "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.email),
      expression: "form.email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.disableEditEmail
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value.trim())
      }, _vm.$v.form.email.$touch],
      "keyup": function($event) {
        _vm.emailChanged = true
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.email.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.email.email) ? _c('span', [_vm._v("Must be a valid email.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-4",
    class: {
      error: _vm.$v.form.phone.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Phone\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }, _vm.$v.form.phone.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.phone.$error) ? _c('div', {
    staticClass: "messages"
  }, [_c('span', [_vm._v("This must be a phone number.")])]) : _vm._e()]), _vm._v(" "), (!_vm.passedForm.isOTA) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Notes "), _c('span', {
    staticClass: "normal"
  }, [_vm._v("(internal note)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), (!_vm.passedForm.isOTA) ? _c('div', {
    staticClass: "mb-5"
  }, [_c('h5', [_vm._v("CONTACTS")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Financial Email\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactFinancialEmail),
      expression: "form.contactFinancialEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactFinancialEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactFinancialEmail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Financial Phone\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactFinancialPhone),
      expression: "form.contactFinancialPhone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactFinancialPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactFinancialPhone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Sales Email\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactSalesEmail),
      expression: "form.contactSalesEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactSalesEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactSalesEmail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Sales Phone\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactSalesPhone),
      expression: "form.contactSalesPhone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactSalesPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactSalesPhone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                General Email\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactOthersEmail),
      expression: "form.contactOthersEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactOthersEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactOthersEmail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                General Phone\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactOthersPhone),
      expression: "form.contactOthersPhone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.contactOthersPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactOthersPhone", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v("BILLING DETAILS")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Billing name "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            VAT number\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.vat),
      expression: "form.vat"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.vat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "vat", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Address\n                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("ZIP Code\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.zip),
      expression: "form.zip"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Location\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.location),
      expression: "form.location"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "location", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.form.country) ? _c('div', {
    staticClass: "col-sm-4 mb-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Country")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getCountries,
      "searchable": true,
      "label": "name",
      "placeholder": "- Select payment -"
    },
    model: {
      value: (_vm.form.country),
      callback: function($$v) {
        _vm.$set(_vm.form, "country", $$v)
      },
      expression: "form.country"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('h5', [_vm._v("Schedule Tasks")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.isWorkflowAllowedToSendEmails),
      callback: function($$v) {
        _vm.$set(_vm.form, "isWorkflowAllowedToSendEmails", $$v)
      },
      expression: "form.isWorkflowAllowedToSendEmails"
    }
  }, [_vm._v("\n                            Allow sending automatic emails\n                        ")])], 1)])])]), _vm._v(" "), _c('div', {
    class: _vm.getSelectedPerson ? 'col-sm-12' : 'col-sm-5'
  })]), _vm._v(" "), (!_vm.getSelectedPerson) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center my-1 p-2"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "submit",
      "value": "Next",
      "disabled": _vm.$v.form.$invalid
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "m-0"
  }, [_vm._v("Name "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2d5607ff", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5607ff"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentForm.vue
// module id = 849
// module chunks = 0